export default __webpack_public_path__ + "static/media/waste-water.b35f54cb.jpg";